import type { Region } from 'state/discover/page/page.model';
import type { AppState } from 'state/state.model';
import { getUserPreferencesDiscoverPageRegion } from 'state/userPreferences/userPreferences.selectors';

import { getDiscoverPageSelectedRegion } from './page/page.selector';

export const defaultRegion = 'Switzerland';
export function getDiscoverRegion(state: AppState): Region {
  return getDiscoverPageSelectedRegion(state) ?? getUserPreferencesDiscoverPageRegion(state) ?? defaultRegion;
}
